import { Box, Typography, Avatar, Button } from "@mui/material";
import { useSelector } from "react-redux";
import { colors } from "../../common/colors";
import profile from "../../assets/images/profile_img.png";
import { convertUserImage } from "../../util/utils";
import { PrivateUser } from "../../util/CreatePost/types";
import { isSamePrivateUser } from "../../util/CreatePost/utils";

interface Props {
  privateUser: PrivateUser;
  isEdit?: boolean;
  onDelete:() => void;
}

function SelectedUser({ privateUser, isEdit = false, onDelete }: Props) {
  const { user } = useSelector((state: any) => state.userAuth);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: "6px",
        borderRadius: "2px",
        border: `1px solid ${colors.farm_green200}`,
        backgroundColor: "#f9f9f9",
        marginRight: "4px",
        marginBottom: "2px",
      }}
    >
      <Avatar
        sx={{ marginRight: "8px" }}
        src={privateUser?.image ? convertUserImage(privateUser?.image) : profile}
        alt={privateUser?.nickname}
      />

      <Typography
        sx={{
          flexGrow: 1,
          flexShrink: 1,
          minWidth: 0, // Allows text to shrink and ellipsis
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {privateUser?.nickname}&nbsp;
      </Typography>
      {!isEdit && !isSamePrivateUser(privateUser, user.class_name, user?.id) && (
        <Button
          onClick={onDelete}
          style={{ minWidth: 30, padding: 0, borderRadius: 50 }}
        >
          <img
            alt=""
            style={{ borderRadius: 50, height: 30 }}
            src={require("../../assets/images/remove_user.png")}
          />
        </Button>
      )}
    </Box>
  );
}

export default SelectedUser;
